const trustItems = [
  {
    icon: 'ri-database-2-line',
    title: 'Aktuelle Daten',
    description: 'Wir analysieren und strukturieren die wichtigsten Oopbuy Spreadsheet Informationen f&uuml;r dich.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Einfach erkl&auml;rt',
    description: 'Auch Anf&auml;nger verstehen den gesamten Prozess – Schritt f&uuml;r Schritt und auf Deutsch.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Sicher einkaufen',
    description: 'Mit unseren Sicherheits- und Qualit&auml;tskontrollen kaufst du immer gesch&uuml;tzt ein.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Regelm&auml;&szlig;ig aktualisiert',
    description: 'Unser Oopbuy Spreadsheet wird kontinuierlich mit neuen Verk&auml;ufern und Produkten aktualisiert.',
  },
];

export default function TrustSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
            Warum unser Oopbuy Spreadsheet Guide?
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            Tausende Nutzer vertrauen bereits auf unsere gepr&uuml;ften Informationen
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {trustItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8 text-center hover:border-accent-300 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} w-6 h-6 md:w-7 md:h-7 flex items-center justify-center text-accent-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}